const moroccoConfig = {
  isZendeskEnabled: false,
  phonePlaceHolder: 'XXXXXXXXX',
  currency: 'DHS',
};

export default moroccoConfig;